import { useMutation, useQueryClient } from '@tanstack/react-query';

import { cacheKeys as authCacheKeys } from '@modules/Auth/config';
import { cacheKeys as disciplinesCacheKeys } from '@modules/Disciplines/config';
import { cacheKeys as majorsCacheKeys } from '@modules/Majors/config';
import { cacheKeys as universitiesCacheKeys } from '@modules/Universities/config';
import { cacheKeys } from '../config';
import { assertionClient } from '../client/assertionClient';


export const useAssertionCrud = () => {
  const queryClient = useQueryClient();

  const answerAssertion = useMutation({
    mutationKey: [cacheKeys.answerAssertions],
    mutationFn: (data: { id: number; answer: Assertions.AnswerValue }) =>
      assertionClient.answerAssertion(data),
    onSuccess: (response) => {
      // Keep the "next" cache in sync with the latest server state
      queryClient.setQueryData([cacheKeys.getNextAssertion], response);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [cacheKeys.getAssertions] });
      queryClient.invalidateQueries({ queryKey: [cacheKeys.getNextAssertion] });
    },
  });

  const previousAssertion = useMutation({
    mutationKey: [cacheKeys.getPreviousAssertion],
    mutationFn: assertionClient.getPreviousAssertion,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [cacheKeys.getAssertions] });
    },
  });

  const calculateMatch = useMutation({
    mutationFn: assertionClient.calculateMatch,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [authCacheKeys.getMe],
      });
      await queryClient.invalidateQueries({
        queryKey: [disciplinesCacheKeys.getDisciplines],
      });
      await queryClient.invalidateQueries({
        queryKey: [disciplinesCacheKeys.getDiscipline],
      });
      await queryClient.invalidateQueries({
        queryKey: [majorsCacheKeys.getMajors],
      });
      await queryClient.invalidateQueries({
        queryKey: [majorsCacheKeys.getMajor],
      });
      await queryClient.invalidateQueries({
        queryKey: [universitiesCacheKeys.getUniversities],
      });
      await queryClient.invalidateQueries({
        queryKey: [universitiesCacheKeys.getUniversity],
      });
    },
  });


  return {
    answerAssertion,
    previousAssertion,
    calculateMatch,
  };
};
